/* eslint-disable @next/next/no-img-element */
/* eslint-disable react/jsx-props-no-spreading */
import React, { useState } from 'react';
import Slider from 'react-slick';
import { ProductDescription } from 'src/modules/parkplusStoreV2/types/product';
import VideoCard from 'src/modules/parkplusStoreV2/uiComponents/Cards/VideoCard';
import { trackSlideChange } from 'src/modules/parkplusStoreV2/utils/events';
import AnimatedImage from 'core-lib/components/AnimatedImage';
import ShimmerImage from 'core-lib/components/ShimmerImage';
import { Badge } from 'ui-v2/components/Badge';
import s from './Carousel.module.scss';
import { RatingTag } from 'ui-v2/components/RatingTag';

type CarouselProps = {
  data: ProductDescription;
  offerCount?: number;
  onReviewClick?: () => void; 
};

export const Carousel: React.FunctionComponent<CarouselProps> = ({
  data,
  offerCount,
  onReviewClick
}) => {
  const [activeSlide, setActiveSlide] = useState(0);
  const settings = {
    className: 'slick_generic_slider store_slider',
    dots: true,
    infinite: true,
    fade: true,
    slide: 'div',
    cssEase: 'linear',
    arrows: false,
    beforeChange: (_, newSlide) => {
      setActiveSlide(newSlide);
      trackSlideChange(newSlide);
    },
  };
  return (
    <div className={s.carousel}>
      <Slider {...settings}>
        {data?.video && (
          <div className={s.videoContainer}>
            <VideoCard
              url={data?.video?.url}
              thumbnailUrl={data?.video?.thumbnail}
              customStyle={{
                height: '378px',
                background: 'none',
              }}
              isActive={activeSlide === 0}
            />
          </div>
        )}
        {data?.descriptionImages?.map((item) => (
          <div className={s.card} key={item} aria-hidden>
            <ShimmerImage src={item} alt="product" className={s.image} />
          </div>
        ))}
      </Slider>

      {data?.coverImageNudge && (
        <div className={s.coverImageNudge}>
          <AnimatedImage src={data.coverImageNudge} alt="coverImageNudge" />
        </div>
      )}

      {data?.rating && (
        <div className={s.ratings} onClick={onReviewClick}>
          <RatingTag size='m' rating={+data?.rating} />
        </div>
      )}
      {offerCount > 0 && (
        <div
          className={s.offers_badge}
          aria-hidden
          onClick={() => {
            window?.scrollTo({
              top: 710,
              behavior: 'smooth',
            });
          }}
        >
          <Badge
            label={
              offerCount > 1
                ? `${offerCount} active offers`
                : `${offerCount} active offer`
            }
          />
        </div>
      )}
    </div>
  );
};
